import { Anchor, Divider, Flex, Text } from "@mantine/core";
import DraftAutoSaveModal from "src/components/shared/_Modals/DraftAutoSaveModal/DraftAutoSaveModal";
import { BackButton } from "src/components/shared/BackButton/BackButton";
import { getOrigin } from "src/environment";
import { ReadonlyFieldset } from "src/generator/Logbook/Logbook.styled";
import { useIsNewEntry } from "src/hooks";
import { useSelector } from "src/redux/hooks";

import ReopenNMEAModalButton from "../_Buttons/ReopenNMEAModalButton";
import SearchRefInput from "../_Buttons/SearchRefInput";
import EntryLockInfo from "../EntryLockInfo/EntryLockInfo";
import EntryText from "../EntryText";
import HamburgerMenu from "../HamburgerMenu/HamburgerMenu";
import LogBarSelects from "../LogBarSelects/LogBarSelects";
import StatusBadge from "../StatusBadge/StatusBadge";

const SmallWidthLogBar = () => {
  const { latestEntry, lbentry } = useSelector(state => state.generatorSlice);
  const isNewEntry = useIsNewEntry();
  const isReadOnly = useSelector(
    state => state.generatorSlice.lbentry.isReadonly,
  );

  return (
    <>
      <Flex
        m={0}
        align="center"
        justify="space-between"
        wrap="wrap"
        gap="20px"
        mb={15}>
        <Flex direction="column">
          <Flex align="center" gap="10px">
            <BackButton />
            <Text
              ml={15}
              mr={15}
              maw={350}
              data-cy="lbname"
              style={{ textTransform: "capitalize" }}>
              {latestEntry.lbName}
            </Text>
            {latestEntry.entryref && (
              <Text maw={400} data-cy="lbentryref">
                Entry Ref. #{latestEntry.entryref}
              </Text>
            )}
            <Flex
              style={{
                borderRadius: "13px",
                backgroundColor: "var(--mantine-color-cardBackground-0)",
              }}>
              <StatusBadge
                status={isNewEntry ? "new" : latestEntry.status}
                autosave={latestEntry.autosave}
                size="lg"
                variant="light"
              />
            </Flex>
            <EntryLockInfo />
            {lbentry?.extraLinks?.map(extra => (
              <>
                <Anchor
                  key={extra.link}
                  size={"xs"}
                  href={
                    !extra.link.includes("http")
                      ? getOrigin() + `${extra.link}`
                      : `${extra.link}`
                  }
                  target="blank">
                  {extra.linkName}
                </Anchor>
              </>
            ))}
          </Flex>
          <Flex pt={15} pb={5}>
            <SearchRefInput />
          </Flex>
          <EntryText />
        </Flex>

        <Flex h="100%" style={{ flex: 1 }} justify="flex-end">
          <ReadonlyFieldset disabled={isReadOnly}>
            <ReopenNMEAModalButton />
            <HamburgerMenu />
          </ReadonlyFieldset>
        </Flex>
      </Flex>

      <Flex direction="column" gap={12} align="flex-end">
        <DraftAutoSaveModal />
        <LogBarSelects gap={50} style={{ width: "100%" }} />
      </Flex>

      <Divider my="sm" />
    </>
  );
};

export default SmallWidthLogBar;
